import createAuth0Client from '@auth0/auth0-spa-js';

let auth0client;

export const getAuth0Client = (customOptions = {}) => {
  if (auth0client) {
    return auth0client;
  }

  const auth0Domain = process.env.AUTH0_DOMAIN;
  const auth0ClientId = process.env.AUTH0_CLIENT_ID;

  const defaultOptions = {
    domain: auth0Domain,
    client_id: auth0ClientId,
    redirect_uri: `${window.location.origin}/`,
    scope: 'openid profile email user_metadata picture',
    audience: `https://${auth0Domain}/api/v2/`,
    ui_locales: 'it',
    language: 'it',
    screen_hint: 'login',
    cacheLocation: 'localstorage',
  };

  const params = Object.assign({}, defaultOptions, customOptions);

  auth0client = createAuth0Client(params);

  return auth0client;
};
